import styled from "styled-components";
import { theme } from "../../theme";
import { CheckmarkIconSmall } from "./icons/CheckmarkIcons";
import { WarningIcon } from "./icons/WarningIcon";
import { CommentIcon } from "./icons/CommentIcon";
import { InfoIconSmall } from "./icons/InfoIcons";
import { CrossIcon } from "./icons/CrossIcon";

interface Props {
  type:
    | "success"
    | "warning"
    | "error"
    | "failed"
    | "comment"
    | "info"
    | "custom";
  icon?: React.ReactNode;
  color?: string;
}

const CircleIconContainer = styled.div<{ color: string }>`
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CircleIcon: React.FC<Props> = ({ type, icon, color }) => {
  const getColor = () => {
    switch (type) {
      case "success":
        return theme.colors.success20;
      case "warning":
        return theme.colors.warning20;
      case "comment":
        return theme.colors.info20;
      case "info":
        return theme.colors.info20;
      case "custom":
        return color || theme.colors.primaryBg;
      case "error":
        return theme.colors.error20;
      case "failed":
        return theme.colors.error20;
      default:
        return theme.colors.primaryBg;
    }
  };

  const getIcon = () => {
    switch (type) {
      case "success":
        return <CheckmarkIconSmall color={theme.colors.success} />;
      case "warning":
        return <WarningIcon color={theme.colors.warning} />;
      case "comment":
        return <CommentIcon color={theme.colors.info} />;
      case "info":
        return <InfoIconSmall color={theme.colors.info} />;
      case "custom":
        return icon || <InfoIconSmall color={theme.colors.primary} />;
      case "error":
        return <WarningIcon color={theme.colors.error} />;
      case "failed":
        return <CrossIcon color={theme.colors.error} />;
      default:
        return <InfoIconSmall color={theme.colors.primary} />;
    }
  };

  return (
    <CircleIconContainer color={getColor()}>
      {icon ?? getIcon()}
    </CircleIconContainer>
  );
};

export default CircleIcon;
